// Generated code, do not edit manually. Run the following command to regenerate it:
// > nx generate-icons packages/systems/plugins/Localization

import {SVGProps, ReactElement, createElement} from 'react';
import type {IconProps} from '@packages/utilities/icon-support';
export default /*#__PURE__#*/ function TempElementLocales(
  props: IconProps
): ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale =
    typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement(
    'svg',
    {
      'data-icon': 'TempElementLocales',
      'aria-hidden': true,
      focusable: false,
      width: 12 * scale,
      height: 12 * scale,
      viewBox: '0 0 12 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {
        ...{
          display: 'block',
        },
        ...props.style,
      },
    },
    createElement('path', {
      fill: 'currentColor',
      d: 'M6.032 1H6C3.257 1 1 3.257 1 6s2.257 5 5 5h.032C8.76 10.982 11 8.732 11 6S8.76 1.018 6.032 1zm2.359 6.305c0 1.077-.641 2.583-1.925 2.607h-.03V8.171s-1.522 0-.87-1.74c0 0-2.609 0-2.609-2.173 0-1.767 1.723-2.24 2.951-2.24h.035c.27.002.514.027.709.066 0 0 .218 1.087-.216 1.74 0 0 .651.652.216 1.086a.383.383 0 01-.272.122h-.012c-.387-.004-.802-.556-.802-.556s-.869.653-.435 1.09C5.566 6 6 6 7.302 6c1.305 0 1.089 1.305 1.089 1.305z',
    })
  );
}
